module.exports = __webpack_public_path__ + "static/media/bh.6a15cdbf.svg";